module.exports = __webpack_public_path__ + "static/5-9edd210f5ae34776cfcaf2114bf0d219.jpg";